import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { style } from '../../utils/style.js';
import { renderErrorText } from '../Input/renderErrorText.js';
import { Checkbox } from './Checkbox.js';
export const CheckboxWithError = JSX(({ className, text, value, key, disabled, error, onChange }) => (_jsxs("div", { className: style('shrink-0 w-full', className), children: [_jsx(Checkbox, { text: text, value: value, disabled: disabled, onChange: onChange }, key), renderErrorText(error)] })));
//# sourceMappingURL=CheckboxWithError.js.map